define(["exports", "styled-components", "../../themes"], function (_exports, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var LabelRows = _styledComponents.default.ul.withConfig({
    displayName: "LabelRows",
    componentId: "sc-oz57v0-0"
  })(["", " display:flex;flex-wrap:wrap;margin-top:16px;margin-bottom:-8px;padding:0;"], _themes.resetList);

  var _default = LabelRows;
  _exports.default = _default;
});